import useSWR from 'swr';

interface VimeoThumbnailProps {
  videoId: string;
}

const fetcher = (url: string) => fetch(url).then((res) => res.json());

const VimeoThumbnail = ({ videoId }: VimeoThumbnailProps) => {
  const { data, isLoading } = useSWR(
    videoId
      ? `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`
      : null,
    fetcher
  );

  if (!data?.thumbnail_url) return null;

  return (
    <>
      <img
        src={data.thumbnail_url}
        className="rounded"
        alt="vimeo-thumbnail"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />

      {isLoading && (
        <div
          className={
            'd-flex align-items-center justify-content-center position-absolute w-100 h-100'
          }
          style={{
            position: 'absolute'
          }}>
          <span className={'loader'} role="status" />
        </div>
      )}
    </>
  );
};

export default VimeoThumbnail;
